import axios from "axios";
import { authHeader } from "../utils/authHeader";

const apiUrl = process.env.REACT_APP_API_URL;

export const list = (page, limit, startDate, endDate, accessToken) => {
  return axios.get(
    apiUrl +
      `/subscription/all/${page}/${limit}/?fromDate=${startDate}&toDate=${endDate}`,
    {
      headers: authHeader(accessToken),
    }
  );
};
